<template>
    <div class="journey">
        <div
            :class="[
                'journey-header',
                { transparent: !showHeaderBackground },
                { inline: inlineHeader },
                { divider: showHeader && showDivider },
            ]">
            <span v-if="showHeader" class="journey-header-label">{{ header.label }}</span>
            <span v-if="header.date" class="journey-header-date">
                {{ header.date }}
            </span>
        </div>
        <Journey :data="data" :showDetailed="showDetailed" showHeader="false" />
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { computed, defineComponent, PropType } from 'vue';
    import { convertToDate } from '@shared/helpers/datetime/datetime';
    import { getLocaleWeekdayShortMonthYear } from '@shared/helpers/datetime/datetime.formatters';
    import { Journey as JourneyModel } from '@ui/components/Journey/Journey.interfaces';
    import Journey from '@ui/components/Journey/Journey.vue';

    export default defineComponent({
        name: 'JourneyFlight',
        methods: { convertToDate, t },
        components: { Journey },
        props: {
            data: {
                type: Object as PropType<JourneyModel>,
                required: true,
            },
            showDetailed: { type: Boolean, default: false },
            showHeader: { type: Boolean, default: true },
            showHeaderBackground: { type: Boolean, default: true },
            showDivider: { type: Boolean, default: false },
            inlineHeader: { type: Boolean, default: false },
            isOutbound: { type: Boolean, default: true },
        },
        setup(props) {
            const header = computed(() => {
                const date = props.data.segments[0].departure.date;

                const label = t({
                    key: props.isOutbound ? 'shared.outbound_flight' : 'shared.homebound',
                });

                return {
                    label,
                    date: date ? getLocaleWeekdayShortMonthYear(date) : null,
                };
            });

            return {
                header,
            };
        },
    });
</script>
